// extracted by mini-css-extract-plugin
export default {"recoveryMethodWrap":"ZW5Qu7","metod":"_3owuoa","metod__img":"_3gOxa4","metod__label":"_3bXBS5","arrowRight":"cci-oF"};